export default __webpack_public_path__ + "static/media/EduTest-white.628fb6e8.svg";